import appControlDriverInstance from 'src/js/modules/read-only-mode/helpers/app-control-driver-instance';
import store from 'src/js/store';
import { dialogs, i18next, readOnly, site, view } from '@yola/ws-sdk';
import reloadSiteMeta from 'src/js/modules/ai-wizard/helpers/reload-site-meta';
import trackReadOnlyControlTaken from 'src/js/modules/analytics/segment/trackers/readonly-control-taken';
import constants from 'src/js/modules/read-only-mode/constants';
import showInactiveTabSavingErrorDialog from '../helpers/show-inactive-tab-saving-error-dialog';

const takeControl = () => {
  const state = store.getState();
  const isReadOnlyModeEnabled = readOnly.selectors.getReadOnlyStatus(state);
  if (!isReadOnlyModeEnabled) return;

  const controlDriverInstance = appControlDriverInstance.get();
  if (!controlDriverInstance) return;

  const activePageId = site.selectors.getActivePageId(state);
  dialogs.operations.hide({ [constants.READONLY_SYMBOL]: true });

  store.dispatch(view.actions.setLoadedStatus(i18next.t('Saving changes from inactive tab...')));
  controlDriverInstance
    .requestAppControl()
    .then(() => {
      store.dispatch(view.actions.setLoadedStatus(i18next.t('Taking over control...')));
      store.dispatch(readOnly.actions.disable());
      reloadSiteMeta().then(() => {
        store.dispatch(site.actions.setActivePage(activePageId));

        trackReadOnlyControlTaken();
      });
    })
    .catch((e) => {
      console.error('Error taking editor control', e);
      showInactiveTabSavingErrorDialog();
      store.dispatch(view.actions.setLoadedStatus(true));
    });
};

export default takeControl;
